<template>
  <b-container fluid class="mt-4">
    <!--    <stripe-checkout ref="checkoutRef" mode="payment" :pk="publishableKey"-->
    <!--                     :session-id="sessionIds[$site]"-->
    <!--                     :success-url="successUrls[$site]"-->
    <!--                     :line-items="lineItems"-->
    <!--    >-->
    <!--    </stripe-checkout>-->
    <b-row class="mb-4">
      <b-col cols="3">
        Balance ${{ finalBalance || currency }}
        <!--        <span v-if="async.balance > 0 && async.shippingUnpaidAllPeriod > 0">-->
        <!--          (${{ async.balance }} - ${{ async.shippingUnpaidAllPeriod }})-->
        <!--        </span>-->
      </b-col>
      <b-col cols="3">
        <b-btn @click="viewBalance">History</b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label for="amount"
          >If you want to deposit some amount at once, fill in the amount and
          click the Deposit button. All the unpaid orders will be paid
          automatically everyday.</label
        >
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col cols="3">
        <b-input
          id="amount"
          v-model="depositAmount"
          type="number"
          min="1"
          placeholder="amount in USD"
        ></b-input>
      </b-col>
      <b-col cols="3">
        <b-btn @click="deposit">Deposit</b-btn>
      </b-col>
    </b-row>

    <b-form @submit.prevent="submit">
      <b-row class="mb-2">
        <b-col md="3" class="my-2">
          <b-select :options="dateTypes" v-model="searchForm.dateType" />
        </b-col>
        <b-col md="3" class="my-2">
          <date-range-picker
            :showDropdowns="true"
            :timePicker="false"
            :timePicker24Hour="true"
            ref="picker"
            v-model="createdAt"
            @update="submit"
            opens="right"
            :autoApply="true"
            :ranges="ranges"
            :linked-calendars="false"
          >
            <template v-slot:input="picker">
              {{ picker.startDate.toLocaleDateString() }} -
              {{ picker.endDate.toLocaleDateString() }}
            </template>
          </date-range-picker>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3" class="my-2">
          <b-select :options="searchFields" v-model="searchForm.searchField">
          </b-select>
        </b-col>
        <b-col md="3" class="my-2">
          <b-input v-model="searchForm.searchValue"></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Shipment Status">
            <b-form-checkbox-group v-model="searchForm.statusArr">
              <b-checkbox value="0">Processing</b-checkbox>
              <b-checkbox value="4">Arrived</b-checkbox>
              <b-checkbox value="5">Shipped</b-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Payment Status"
            @click.native="onPaymentStateClick"
          >
            <b-form-checkbox-group v-model="searchForm.paymentStateArr">
              <b-checkbox value="2">Paid</b-checkbox>
              <b-checkbox value="0">Unpaid</b-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-2">
        <b-col>
          <b-btn type="submit">Submit</b-btn>
        </b-col>
      </b-row>
    </b-form>

    <b-modal id="payment" @ok="createLink" hide-header>
      付款金额
      <b-input v-model="paymentAmount"></b-input>
      <p>
        点击OK按钮付款，系统会自动发货。在<b class="text-danger">确认收货</b
        >后，系统将自动为您充值对应金额。
      </p>
      <u><b>交易结束以后请不要评价</b></u
      >！淘宝会以为虚假交易，会处罚！
    </b-modal>
    <ul>
      <li>🎬: {{ $t("Not arrived yet") }}</li>
      <li>❗: {{ $t("Has an issue") }}</li>
      <li>🚚: {{ $t("Shipping domestically") }}</li>
      <li>🏤: {{ $t("Arrived at our warehouse") }}</li>
      <li>✈: {{ $t("shipped internationally") }}</li>
      <li>⭕: {{ $t("paid") }}</li>
      <li>🔺: {{ $t("Paid temporarily") }}</li>
      <li>❌: {{ $t("Not paid yet") }}</li>
    </ul>
    <b-table
      responsive
      sticky-header="800px"
      :tbody-tr-class="rowClass"
      :fields="fields"
      :items="async.items"
      @row-clicked="loadDetails"
      style="cursor: pointer; height: 20%; margin-bottom: 100px"
    >
      <!--      <template #cell(paid)="row">-->
      <!--        <span v-if="row.product.paid === 2" class="bg-danger">-->
      <!--          <i class="fa fa-circle-o"></i>-->
      <!--          <span class="text-success">⬤</span> Paid-->
      <!--        </span>-->
      <!--        <span v-else>-->
      <!--          <i class="fa fa-circle-o"></i>-->
      <!--          <span class="text-danger">⬤</span> Unpaid-->
      <!--        </span>-->
      <!--      </template>-->
      <template #cell(stock)="row">
        <b-btn
          v-if="row.item.defer == 2"
          @click="setStockedMode(row, 0)"
          variant="danger"
        >
          Ship
        </b-btn>
        <b-btn
          v-else-if="row.item.defer == 0"
          @click="setStockedMode(row, 2)"
          variant="warning"
        >
          Stock
        </b-btn>
      </template>
      <template #cell(paymentStateIcon)="row">
        <span
          v-if="row.item.paymentStateText === 'payment confirmed'"
          variant="success"
        >
          {{ row.item.paymentStateIcon }}
        </span>
        <b-btn
          v-else-if="row.item.chargeUSD > 0"
          @click="openPaymentWindow(row.item)"
          variant="warning"
        >
          Pay
        </b-btn>
      </template>
      <template #cell(delete)="row">
        <b-btn
          v-if="row.item.status < 4"
          @click="deleteLogi(row)"
          variant="danger"
        >
          Delete
        </b-btn>
      </template>
      <template #cell(tnum)="row">
        <a target="_blank" :href="trackingLinks[$data.$site] + row.item.tnum">{{
          row.item.tnum
        }}</a>
      </template>
      <template #cell(combine)="row">
        <b-btn
          v-if="combinedOrders.includes(row.item.idx)"
          @click="cancelCombine(row)"
          variant="danger"
        >
          Cancel
        </b-btn>

        <b-btn
          v-else-if="
            combinedOrders.length > 0 && !combinedOrders.includes(row.item.idx)
          "
          @click="setCombinedOrders(row)"
          variant="warning"
        >
          Choose
        </b-btn>
        <b-btn v-else @click="setCombinedOrders(row)" variant="warning"
          >Combine</b-btn
        >
      </template>
      <template #cell(image)="row">
        <b-img lazy width="50" height="50" :src="row.item.img" />
      </template>
      <template #row-details="row">
        <b-table
          responsive
          :fields="feeItemsFields"
          :items="row.item.fees"
          @row-clicked="edit"
          style="cursor: pointer"
          thead-class="hidden_header"
        >
          <template #cell(uncombine)="fee">
            <b-btn
              variant="warning"
              v-if="row.item.fees.length >= 2"
              @click="uncombine(fee.item.feecode, fee.item.logicode)"
            >
              Uncombine
            </b-btn>
          </template>
          <template #cell(image)="fee">
            <b-img width="50" height="50" :src="fee.item.img" />
          </template>
          <template #row-details="fee">
            <b-table
              responsive
              :fields="orderItemsFields"
              :items="fee.item.orders"
              @row-clicked="edit"
              style="cursor: pointer"
            >
              <template #cell(deliverydate_info)="order">
                <span v-if="[1, 6, 7].includes(order.item.status)">{{
                  order.item.error
                }}</span>
                <span v-else-if="[2, 3].includes(order.item.status)">{{
                  order.item.deliverydate_info
                }}</span>
                <span v-else-if="[4].includes(order.item.status)">{{
                  $t("In warehouse")
                }}</span>
                <span v-else-if="[5].includes(order.item.status)">{{
                  $t("Shipped internationally")
                }}</span>
              </template>
              <template #cell(image)="order">
                <b-img width="50" height="50" :src="order.item.img" />
              </template>
            </b-table>
          </template>
        </b-table>
      </template>
    </b-table>

    <b-alert
      v-model="combinedOrders.length > 0"
      class="position-fixed fixed-bottom m-0 rounded-0 text-center"
      style="z-index: 2000"
      variant="warning"
    >
      <p>{{ combinedOrders.join(", ") }}</p>
      <p v-if="combinedOrders.length === 1">
        {{ $t("Choose items to combine.") }}
      </p>
      <b-btn v-else @click="combineOrders">{{
        $t("Combine above orders")
      }}</b-btn>
    </b-alert>
  </b-container>
</template>

<script>
// import 'axios-progress-bar/dist/nprogress.css'
// import { loadProgressBar } from 'axios-progress-bar'
//
// loadProgressBar()

import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { StripeElements, StripeCheckout } from "@vue-stripe/vue-stripe";

export default {
  name: "Orders",
  components: {
    StripeCheckout,
    StripeElements,
    DateRangePicker,
  },
  data() {
    const ranges = {};
    const monthNow = new Date().getMonth();
    for (let i = -1; i < 6; i++) {
      const currentMonth = monthNow - i;

      const nextMonthObj = new Date(new Date().getFullYear(), currentMonth, 1);
      const currentMonthObj = new Date(
        new Date().getFullYear(),
        currentMonth - 1,
        1
      );

      const monthName = currentMonthObj.toLocaleString("default", {
        month: "short",
      });
      ranges[monthName] = [currentMonthObj, nextMonthObj];
    }
    return {
      depositLinks: {
        jg: "/stripe-link/jiggujiggu",
        un: "/stripe-link/uniauc",
      },
      stripeLinks: {
        jg: "https://api.jiggujiggu.com/redirect-stripe/jiggujiggu",
        un: "https://kr.api.uniauc.com/redirect-stripe/uniauc",
      },
      trackingLinks: {
        jg: "https://www.jiggujiggu.com/jiggu/track.php?tnum=",
        un: "https://m42.uniauc.com/m4/trackall.php?tnum=",
      },
      successUrls: {
        jg: "https://new.jiggujiggu.com/orders",
        un: "",
      },
      sessionIds: {
        jg: "cs_test_a1IKfh8cRS3k6hue8sb83T8WpVUwf1UGFxZBPsqPJFCMuTIzIE3s8Npllu",
        un: "",
      },
      finalBalance: 0,

      dateTypes: [
        {
          text: "Created between",
          value: "writeday",
        },

        {
          text: "Arrived between",
          value: "arriveday",
        },

        {
          text: "Shipped between",
          value: "shipday",
        },
      ],
      // test mode key
      publishableKey:
        "pk_test_51KWOg6IE4SmX7Obh9SSFX7iwqU0YUpBtD8wHFkYf0EpbUuBm9IYVWfO5j4tQfKDPmO1FXwgYLyRo3QZDu9NU9SBo00zTxgsYhh",
      // publishableKey:"pk_live_51KWOg6IE4SmX7ObhcOzZ4XeApLN4rR6FSQR1vwHOj2QX2UZd2FF5MMkgoOVkuUGOb5kxghRfb4lSK4nzn34QxqCC00qypzN695",
      lineItems: [
        {
          // test mode price usd
          price: "price_1L6v15IE4SmX7ObhmlLnWCtE", // The id of the one-time price you created in your Stripe dashboard
          // test mode price eur
          // price: 'price_1L6v1pIE4SmX7ObhvNzRieLr', // The id of the one-time price you created in your Stripe dashboard
          // live usd
          // price: 'price_1L0oxnIE4SmX7ObhiF5SuV8N', // The id of the one-time price you created in your Stripe dashboard
          // live eur
          // price: 'price_1L70HcIE4SmX7Obh7RmZvxge', // The id of the one-time price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      isPaymentSubmitted: false,
      payIdx: 0,
      combinedLogicodes: [],
      combinedOrders: [],
      combiningOrder: 0,
      depositAmount: "",
      paymentAmount: "",
      toBePaid: 0,
      show: { payment: false },
      searchForm: {
        statusArr: [],
        paymentStateArr: [],
        dateType: "writeday",
        searchField: "trade_id",
        searchValue: "",
        // searchType: "partly"
      },
      searchFields: [
        { value: "trade_id", text: this.$t("Order Number") },
        { value: "tnum", text: this.$t("Tracking Number") },
        { value: "idx", text: this.$t("Item Number") },
      ],
      ranges,
      createdAt: {
        startDate: new Date(
          new Date(Date.now() - 1 * 30 * 86400 * 1000).toLocaleDateString()
        ),
        endDate: new Date(
          new Date(Date.now() + 2 * 86400 * 1000).toLocaleDateString()
        ),
      },
      async: {
        orders: [],
        unpaidTotal: 0,
      },
      // {key:"$1",label:this.\$t("$1")},
      fields: [
        // { key: "userid", label: this.$t("Username") },
        { key: "paymentStateIcon", label: "$" },
        { key: "stock" },
        { key: "combine" },
        { key: "delete" },
        { key: "idx", label: this.$t("Number") },
        { key: "image" },
        { key: "weight", label: "⚖️" },
        { key: "chargeUSD", label: this.$t("Ship. Fee") },
        { key: "stateIcon", label: "📦" },
        { key: "region", label: this.$t("Region") },
        { key: "tnum", label: this.$t("Tracking No.") },
        // { key: "currentStatusHtml", label: this.$t("Courier Status") },
        { key: "createdAt", label: this.$t("Order") },
        { key: "arrivedAt", label: this.$t("Arrival") },
        { key: "shippedAt", label: this.$t("Ship") },
        { key: "name", label: this.$t("Name") },
        { key: "adr1", label: this.$t("Address 1") },
        { key: "adr2", label: this.$t("Address 2") },
        { key: "zip", label: this.$t("Zip code") },
        { key: "hand", label: this.$t("Phone") },
        // {key: "tel", label: this.$t("Phone 2")}
        // {key: "tel", label: this.$t("Phone 2")}
      ],
      feeItemsFields: [
        { key: "feecode", label: this.$t("Box Code") },
        { key: "discount", label: this.$t("Discount") },
        { key: "freight", label: this.$t("Shipping") },
        { key: "tax", label: this.$t("Tax") },
        { key: "uncombine", label: this.$t("Uncombine") },
        // { key: "deliverydate_info", label: this.$t("Delivery info") },
        // { key: "stateIcon", label: this.$t("State") }
        // {key:"region",label:this.$t("region")},
      ],
      orderItemsFields: [
        { key: "idx", label: this.$t("Number") },
        { key: "image", label: this.$t("Image") },
        { key: "title", label: this.$t("Title") },
        { key: "price", label: this.$t("Price") },
        // { key: "charged", label: this.$t("Charged") },
        { key: "cnt", label: this.$t("Qty") },
        { key: "deliverydate_info", label: this.$t("Delivery info") },
        { key: "status", label: this.$t("State") },
        // {key:"region",label:this.$t("region")},
      ],
    };
  },
  methods: {
    onPaymentStateClick(evt) {
      if (this.searchForm.paymentStateArr.length)
        this.searchForm.statusArr = [];
      else this.searchForm.statusArr = [4, 5];
    },
    async openPaymentWindow({ idx, chargeUSD }) {
      window.open(
        `${
          this.stripeLinks[this.$data.$site]
        }?referenceId=${idx}&amount=${chargeUSD}&type=${this.$data.$site}-pay`
      );
    },
    async deposit() {
      if (!this.depositAmount) {
        this.$warn("Please fill in the deposit amount.");
        return false;
      }
      const url = await this.$post(this.depositLinks[this.$data.$site], {
        amount: this.depositAmount,
        type: this.$data.$site + "-deposit",
        userId: this.$store.state.user.id,
        userEmail: this.$store.state.user.email,
      });
      location.href = url;
    },
    async checkOut() {
      this.$refs.checkoutRef.redirectToCheckout();
    },
    async pay(row) {
      this.$refs["ccFormModal"].show();
      this.payIdx = row.item.idx;
    },
    async uncombine(feecode, logicode) {
      await this.$post(`/uncombine-order`, { feecode, logicode });
    },
    async setStockedMode(row, defer) {
      await this.$post(`/set-stocked-mode/${row.item.idx}`, { defer });
      row.item.defer = defer;
    },
    async deleteLogi(row) {
      if (!confirm("Are you sure to proceed?")) return false;
      await this.$post(`/delete-logi`, { idx: row.item.idx });
      await this.init();
    },
    async combineOrders() {
      const combined = await this.$post("/combine-orders", {
        combinedLogicodes: this.combinedLogicodes,
      });
      if (!combined.error) location.reload();
    },
    setCombinedOrders(row) {
      this.combinedOrders.push(row.item.idx);
      this.combinedLogicodes.push(row.item.logicode);
    },
    cancelCombine(row) {
      this.combinedOrders = this.combinedOrders.filter(
        (idx) => idx !== row.item.idx
      );
      this.combinedLogicodes = this.combinedLogicodes.filter(
        (logicode) => logicode !== row.item.logicode
      );
    },
    edit(order) {
      window.open(
        "/mypage/input_apply.php?act=edit&feecode=" +
          order.feecode +
          "&logicode=" +
          order.logicode +
          "&status=" +
          order.status +
          "&paid=" +
          order.paid +
          "&sdefer="
      );
    },
    truncate(text) {
      if (!text) return "";
      return text.substr(0, 30);
    },
    rowClass(item, type) {
      if (!item || type !== "row") return "";
      else if (item.stateText === "canceled") return "table-canceled";
      else if (item.stateText === "canceling") return "table-canceling";
      else if (item.stateText === "shipped") return "table-success";
      else if (item.stateText === "arrived") return "table-danger";
      else if (item.stateText === "already ordered") return "table-info";
      else if (item.stateText === "errored") return "table-warning";
    },
    openURL(item) {
      window.open(item.url);
    },
    async loadDetails(item, index, event) {
      if (!item._showDetails) {
        const fees = await this.$get("/order-items/" + item.logicode);
        for (const fee of fees) {
          fee._showDetails = true;
        }
        item.fees = fees;
        console.log(fees);
      }
      this.$set(item, "_showDetails", !item._showDetails);
    },
    makeRanges() {},
    async submit() {
      const { startDate, endDate } = this.createdAt;

      if (!this.searchForm.searchValue) {
        this.searchForm.startDate = startDate.toLocaleString("ja");
        this.searchForm.endDate = endDate.toLocaleString("ja");
      }
      this.async = await this.$get("/shippings", {
        params: this.searchForm,
      });
      this.finalBalance = (
        this.async.balance - this.async.shippingUnpaidAllPeriod
      ).toFixed(2);
      if (this.finalBalance < 0) this.depositAmount = -this.finalBalance;
      const realBalance =
        this.async.shippingUnpaid +
        this.async.orderUnpaidTotal -
        this.async.balance;
      this.toBePaid = realBalance > 0 ? realBalance.toFixed(2) * 1 : 0;
      this.paymentAmount = this.toBePaid;
    },
    viewBalance() {
      this.$router.push("/billing");
    },
    async createLink(bvModalEvt) {
      if (this.paymentAmount < this.toBePaid) {
        this.$warn("付款金额不能少于待支付金额");
        bvModalEvt.preventDefault();
        return false;
      }
      const link = await this.$get("/tb/create-deposit-item", {
        params: { amount: this.paymentAmount },
      });
      location.href = link;
    },
    async init() {
      if (
        this.$store.state.user.nick !== "tball" &&
        this.fields[0].key === "userid"
      ) {
        this.fields.unshift({ key: "userid", label: this.$t("Username") });
      }
      this.submit();
      if (this.$route.query.modalShow) {
        this.$bvModal.show("payment");
        console.log();
      }
    },
  },
  watch: {
    currentPage(newPage) {
      console.log(newPage);
      this.$router.push({
        params: { page: newPage },
        query: this.$route.query,
      });
      this.init();
    },
    $route: "init",
    "$store.state.user.nick": "init",
  },
  async mounted() {
    this.init();
  },
};
</script>
<style>
.table-canceled {
  text-decoration: line-through;
}

.table-canceling {
  background-color: lightgray;
  text-decoration: line-through;
}

.manage-data {
  width: 19%;
  display: inline;
  margin-right: 1%;
}

.hidden_header {
  display: none;
}
</style>
